import { createAction, props } from '@ngrx/store';
import {
  ReferralRequestParams,
  ReferralResponse,
} from '@fantaz/shared/data-access/models';

export const init = createAction(
  '[Referrals Page] Init',
  props<{
    options: ReferralRequestParams;
  }>(),
);

export const refetch = createAction('[Referrals Page] Refetch');

export const loadReferralsSuccess = createAction(
  '[Referrals/API] Load Referrals Success',
  props<{ referrals: ReferralResponse }>(),
);

export const loadReferralsFailure = createAction(
  '[Referrals/API] Load Referrals Failure',
  props<{ error: any }>(),
);
